import { apiPost } from '@/utils/httpClient'
import { RequestOptions } from '@/models/RequestOptions'

export const archiveApi = {
    getUserArchivedDocuments(paging: RequestOptions) {
        return apiPost('archive/getDocuments', paging);
    },

    deleteArchiveDocument(documentId: number) {
        return apiPost(`archive/deleteDocument/${documentId}`);
    },

    archiveDocument(documentId: number) {
        return apiPost(`archive/archiveDocument/${documentId}`);
    }
}
